import { Sale } from ".";

export class RecoverySale {
	ID:number = 0;
	SaleID:number = 0;
	ContactID:number = 0;
	LastModified:Date = new Date();
	ComputedFriendlyID:string = "";
	JsonData:Sale = new Sale();

	public constructor(data?:any){
		if (!data) return;
		this.ID = data.ID;
		this.SaleID = data.SaleID;
		this.ContactID = data.ContactID;
		this.LastModified = new Date(data.LastModified);
		this.ComputedFriendlyID = data.ComputedFriendlyID;
		if (data.JsonData) {
			this.JsonData = new Sale(JSON.parse(data.JsonData));
		}
	}
}